import { render, staticRenderFns } from "./CCL.vue?vue&type=template&id=20f7cfa4&scoped=true"
import script from "./CCL.vue?vue&type=script&lang=js"
export * from "./CCL.vue?vue&type=script&lang=js"
import style0 from "./CCL.vue?vue&type=style&index=0&id=20f7cfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7cfa4",
  null
  
)

export default component.exports